<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';
import CommonService from '@/services/common';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
import Dropdown from 'primevue/dropdown';

import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'


export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    ResponsiveButton, Dropdown
  },
  data(){
    return {
        monthDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),

        //First Grid
        columnsFirstGrid: [],
        dataFirstGrid: [],
        columnConfigurationsFirstGrid: [],

        //Second Grid
        columnsSecondGrid: [],
        dataSecondGrid: [],
        columnConfigurationsSecondGrid: [],

        //Third Grid
        columnsThirdGrid: [],
        dataThirdGrid: [],
        columnConfigurationsThirdGrid: [],

        grandTotal: [],

        loadingFirst: false,
        loadingSecond: false,
        loadingThird: false,
        loadingFourth: false,
        loadingFifth: false,
        loadingSixth: false,
        loadingTotal: false,
        isClosed: false,
        idPricedQuantitiesBalance: null,
        showImportDialog: false,
        importDensityEstimationAndFeedstockTanks: false,
        trueUpType: null,
        trueUpTypeOptions: ['Type A', 'Type B'],

        //First Grid Tolling
        columnsTollingFirstGrid: [],
        dataTollingFirstGrid: [],
        columnConfigurationsTollingFirstGrid: [],

        //Second Grid Tolling
        columnsTollingSecondGrid: [],
        dataTollingSecondGrid: [],
        columnConfigurationsTollingSecondGrid: [],

        //Third Grid Tolling
        columnsTollingThirdGrid: [],
        dataTollingThirdGrid: [],
        columnConfigurationsTollingThirdGrid: [],

        //Fourth Grid Tolling
        columnsTollingFourthGrid: [],
        dataTollingFourthGrid: [],
        columnConfigurationsTollingFourthGrid: [],

        //Fifth Grid Tolling
        columnsTollingFifthGrid: [],
        dataTollingFifthGrid: [],
        columnConfigurationsTollingFifthGrid: [],

        //Sixth Grid Tolling
        columnsTollingSixthGrid: [],
        dataTollingSixthGrid: [],
        columnConfigurationsTollingSixthGrid: [],
    }
  },
  validations(){
    return {
        
    }
  },
  watch:{
    'trueUpType'(){
        this.getGrid();
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    //this.configuration = config.getConfiguration('PricedQuantitiesBalance');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'FinalInvoice.page_title');
  },
  methods: {
    getGrid(){
        this.isClosed = false;
        this.getFirstGrid();
        this.getSecondGrid();
        this.getThirdGrid();
        this.getGrandTotal();
        this.getPricedQuantityBalance();
        this.getTollingFirstGrid();
        this.getTollingSecondGrid();
        this.getTollingThirdGrid();
        this.getTollingFourthGrid();
        this.getTollingFifthGrid();
        this.getTollingSixthGrid();
    },
    getFirstGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingFirst = true;
        Service.getFinalInvoiceGetTotalPricedQuantity(body, response => {
            if(response.success){
                this.dataFirstGrid = response.data.data;
                this.columnConfigurationsFirstGrid = response.data.columnConfigurations;
                this.generateColumnsFirstGrid(response.data.columnConfigurations);
            }
            this.loadingFirst = false;
        });
    },
    generateColumnsFirstGrid(columnConfigurationsFirstGrid){
        
        this.columnsFirstGrid = [];
        
        for(let i= 0; i<columnConfigurationsFirstGrid.length; i++){
            let columnConfiguration = columnConfigurationsFirstGrid[i];

            this.columnsFirstGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getSecondGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }

        this.loadingSecond = true;
        Service.getFinalInvoiceGetDeltaPrice(body, response => {
            if(response.success){
                this.dataSecondGrid = response.data.data;
                this.columnConfigurationsSecondGrid = response.data.columnConfigurations;
                this.generateColumnsSecondGrid(response.data.columnConfigurations);
            }
            this.loadingSecond = false;
        }); 
    },
    generateColumnsSecondGrid(columnConfigurationsSecondGrid){
        
        this.columnsSecondGrid = [];
        
        for(let i= 0; i<columnConfigurationsSecondGrid.length; i++){
            let columnConfiguration = columnConfigurationsSecondGrid[i];

            this.columnsSecondGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getThirdGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingThird = true;
        Service.getFinalInvoiceGetTotalFinalInvoice(body, response => {
            if(response.success){
                this.dataThirdGrid = response.data.data;
                this.columnConfigurationsThirdGrid = response.data.columnConfigurations;
                this.generateColumnsThirdGrid(response.data.columnConfigurations);
            }
            this.loadingThird = false;
        });
    },
    generateColumnsThirdGrid(columnConfigurationsThirdGrid){
        
        this.columnsThirdGrid = [];
        
        for(let i= 0; i<columnConfigurationsThirdGrid.length; i++){
            let columnConfiguration = columnConfigurationsThirdGrid[i];

            this.columnsThirdGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getGrandTotal(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingTotal = true;
        Service.getFinalInvoiceGetGrandTotal(body, response => {
            if(response.success){
                this.grandTotal = response.data;
            }
            this.loadingTotal = false;
        });
    },
    rowClass(){
        return 'column-class'
    },
    grandTotalClass(){
        return 'grand-total'
    },
    calculate(){
        this.importDensityEstimationAndFeedstockTanks = false;
    
        this.$confirm.require({
            message: this.$t('messages.calculate_true_up'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {                  
                this.showImportDialog = true;
            },
            reject: () => {
                this.$confirm.close();
            }
        });
    },
    setBodyAndCalculate(importInterfaceFlag){
        let body = {
            monthStartDate: Utils.formatDateForAPI(this.monthDate),
            importDensityEstimationAndFeedstockTanks: importInterfaceFlag
        }
        this.showImportDialog = false;
        this._calculate(body);
    },
    _calculate(body){
        this.$store.dispatch("generic/setLoading", true);
        Service.calculateFinalInvoice(body, response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                this.getGrid();
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    },
    exportExcel(){
        let body = {
            referenceDate: Utils.formatDateForAPI(Utils.dateToCurrentTimeZone(this.monthDate)),
        };

        this.$store.dispatch("generic/setLoading", true);
        let fileNameWithExtension = Utils.formatDateMonth(this.monthDate) + " True_Up.xlsx";
        Service.exportTrueUpCompleteExcel(body, ({success, data, message}) => {
            this.$store.dispatch("generic/setLoading", false);
    
            if(success){
                var fileURL = window.URL.createObjectURL(new Blob([data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileNameWithExtension);
                document.body.appendChild(fileLink);
            
                fileLink.click();
            } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    },
    getPricedQuantityBalance(){
        let filters = [];
        this.idPricedQuantitiesBalance = null;
        
        filters.push({
            operator: '=',
            value: Utils.formatDateForAPI(this.monthDate),
            property: 'MonthStartDate',
        });

        let body = {
            filter: JSON.stringify(filters)
        }

        CommonService.loadGeneric('true-up/priced-quantity-balance', body, response => {
            if(response.success && response.data){
                this.isClosed = response.data[0].isClosed;
                this.idPricedQuantitiesBalance = response.data[0].id;
            }
        });
    },	
	updatePricedQuantitiesBalance(){
        this.$confirm.require({
            message: this.isClosed ? this.$t('PricedQuantitiesBalance.open_priced_quantities_balance') : this.$t('PricedQuantitiesBalance.close_priced_quantities_balance'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {                  
                let body = {
                    id: this.idPricedQuantitiesBalance,
                    monthStartDate: Utils.formatDateForAPI(this.monthDate),
                    isClosed: !this.isClosed
                }

                this.$store.dispatch("generic/setLoading", true);
                Service.updatePricedQuantitiesBalanceGrid(body, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        this.getGrid();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            },
            reject: () => {
                this.$confirm.close();
            }
        });
    },
    getTollingFirstGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        Service.getTrueUpFinalInvoiceTolling(body, response => {
            if(response.success){
                this.dataTollingFirstGrid = response.data.data;
                this.columnConfigurationsTollingFirstGrid = response.data.columnConfigurations;
                this.generateColumnsTollingFirstGrid(response.data.columnConfigurations);
            }
        });
    },
    generateColumnsTollingFirstGrid(columnConfigurationsTollingFirstGrid){
        
        this.columnsTollingFirstGrid = [];

        for(let i= 0; i < columnConfigurationsTollingFirstGrid.length; i++){
            let columnConfiguration = columnConfigurationsTollingFirstGrid[i];

            this.columnsTollingFirstGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getTollingSecondGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }

        this.loadingSecond = true;
        Service.getTrueUpFinalPriceTolling(body, response => {
            if(response.success){
                this.dataTollingSecondGrid = response.data.data;
                this.columnConfigurationsTollingSecondGrid = response.data.columnConfigurations;
                this.generateColumnsTollingSecondGrid(response.data.columnConfigurations);
            }
            this.loadingSecond = false;
        }); 
    },
    generateColumnsTollingSecondGrid(columnConfigurationsTollingSecondGrid){
        
        this.columnsTollingSecondGrid = [];
        
        for(let i= 0; i<columnConfigurationsTollingSecondGrid.length; i++){
            let columnConfiguration = columnConfigurationsTollingSecondGrid[i];

            this.columnsTollingSecondGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getTollingThirdGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingThird = true;
        Service.getTrueUpFinalInvoiceAmount(body, response => {
            if(response.success){
                this.dataTollingThirdGrid = response.data.data;
                this.columnConfigurationsTollingThirdGrid = response.data.columnConfigurations;
                this.generateColumnsTollingThirdGrid(response.data.columnConfigurations);
            }
            this.loadingThird = false;
        });
    },
    generateColumnsTollingThirdGrid(columnConfigurationsTollingThirdGrid){
        
        this.columnsTollingThirdGrid = [];
        
        for(let i= 0; i<columnConfigurationsTollingThirdGrid.length; i++){
            let columnConfiguration = columnConfigurationsTollingThirdGrid[i];

            this.columnsTollingThirdGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getTollingFourthGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingFourth = true;
        Service.getTrueUpTollingPrice(body, response => {
            if(response.success){
                this.dataTollingFourthGrid = response.data.data;
                this.columnConfigurationsTollingFourthGrid = response.data.columnConfigurations;
                this.generateColumnsTollingFourthGrid(response.data.columnConfigurations);
            }
            this.loadingFourth = false;
        });
    },
    generateColumnsTollingFourthGrid(columnConfigurationsTollingFourthGrid){
        
        this.columnsTollingFourthGrid = [];
        
        for(let i= 0; i<columnConfigurationsTollingFourthGrid.length; i++){
            let columnConfiguration = columnConfigurationsTollingFourthGrid[i];

            this.columnsTollingFourthGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getTollingFifthGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingFifth = true;
        Service.getTrueUpTollingInvoiceAmount(body, response => {
            if(response.success){
                this.dataTollingFifthGrid = response.data.data;
                this.columnConfigurationsTollingFifthGrid = response.data.columnConfigurations;
                this.generateColumnsTollingFifthGrid(response.data.columnConfigurations);
            }
            this.loadingFifth = false;
        });
    },
    generateColumnsTollingFifthGrid(columnConfigurationsTollingFifthGrid){
        
        this.columnsTollingFifthGrid = [];
        
        for(let i= 0; i<columnConfigurationsTollingFifthGrid.length; i++){
            let columnConfiguration = columnConfigurationsTollingFifthGrid[i];

            this.columnsTollingFifthGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },

    getTollingSixthGrid(){
        let body  = {
            monthDate: Utils.formatDateForAPI(this.monthDate),
        }
        this.loadingSixth = true;
        Service.getTrueUpTollingDeltaAmount(body, response => {
            if(response.success){
                this.dataTollingSixthGrid = response.data.data;
                this.columnConfigurationsTollingSixthGrid = response.data.columnConfigurations;
                this.generateColumnsTollingSixthGrid(response.data.columnConfigurations);
            }
            this.loadingSixth = false;
        });
    },
    generateColumnsTollingSixthGrid(columnConfigurationsTollingSixthGrid){
        
        this.columnsTollingSixthGrid = [];
        
        for(let i= 0; i < columnConfigurationsTollingSixthGrid.length; i++){
            let columnConfiguration = columnConfigurationsTollingSixthGrid[i];

            this.columnsTollingSixthGrid.push({
                data: columnConfiguration.id,
                type: 'decimal',
                label: columnConfiguration.weeklyDescription,
                decimalPrecision: 3
            });
        }
    },
  }
}

</script>

<template>
    <main>
        <Dialog v-model:visible="showImportDialog" modal header="Import Interfacce" :style="{ width: '40rem' }">
            <div class="flex align-items-center gap-3 mb-3">
                <label for="message" style="font-size: 2rem;" class="flex-end pi pi-exclamation-triangle" />
                <span id="message" style="font-size: 1rem; font-family: Arial, Helvetica, sans-serif;" class="flex-end mx-2">{{$t('messages.import_interface')}}</span>
            </div>
            <template #footer>
                <div class="">
                    <ResponsiveButton style="width: 50px;" :label="$t('no')"  class="p-button-outlined" @click="setBodyAndCalculate(false)" />
                    <ResponsiveButton style="width: 50px;" :label="$t('yes')" class="p-button-solid" @click="setBodyAndCalculate(true)"/>
                </div>

            </template>

        </Dialog>
        <div class="m-5">
            <div class="grid">
                <div class="col-2">
                    <label for="monthStartDate">{{$t('PricedQuantitiesBalance.monthStartDate')}}</label>
                    <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="monthDate"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <div class="col-2 lg:col-2">
                    <label for="version">{{$t('RollingInventory.version')}}</label>
                    <Dropdown v-model="trueUpType" :options="trueUpTypeOptions" class="w-full" />
                </div>

                <div class="col-12 lg:col-4 mx-3 my-3">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="m-2 p-button-sm" @click="getGrid()"/>
                    <ResponsiveButton :label="$t('btn.calculate')" icon="pi pi-percentage" class="m-2 p-button-success p-button-sm" @click="calculate()" 
                    v-if="!uiPermissions('FinalInvoiceCalculateButton').isHidden && this.idPricedQuantitiesBalance && !this.isClosed" />
                    <ResponsiveButton :label="$t('btn.export')" v-if="this.idPricedQuantitiesBalance" icon="pi pi-file-excel" class="m-2 p-button-sm" @click="exportExcel()" />
                    <ResponsiveButton :label="$t('PricedQuantitiesBalance.isClosed')" icon="pi pi-lock" v-if="this.idPricedQuantitiesBalance && this.isClosed"
                    class="m-2 p-button-sm" @click="updatePricedQuantitiesBalance()" />
                    <ResponsiveButton :label="$t('PricedQuantitiesBalance.isOpen')" icon="pi pi-lock-open" v-if="this.idPricedQuantitiesBalance && !this.isClosed"
                    class="m-2 p-button-sm p-button-outlined" @click="updatePricedQuantitiesBalance()" />
                </div>
                
                <div class="col-12" v-if="trueUpType == 'Type A'">
                    <DataTable :value="dataFirstGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingFirst">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.quantities') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsFirstGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type A'">
                    <DataTable :value="dataSecondGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingSecond">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.deltaPrices') }}</h4>
                        </template>

                        <Column field="description" header="Delta Price" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.currency')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsSecondGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type A'">
                    <DataTable :value="dataThirdGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingThird">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.totalFinalInvoices') }}</h4>
                        </template>

                        <Column field="description" header="True-Up" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.currency')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsThirdGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-4" v-if="trueUpType == 'Type A'">
                    <Card v-if="grandTotal.length > 0">
                        <template #content>
                            <DataTable :value="grandTotal" :rowClass="grandTotalClass" :loading="loadingTotal">

                                <Column field="description" header="Total" style="min-width: 100px;">
                                    <template #body="{ data }">
                                        {{ data.description }}
                                    </template>
                                </Column>

                                <Column field="currencyCode" style="min-width: 100px;">
                                    <template #body="{ data }">
                                        {{ data.currencyCode }}
                                    </template>
                                </Column>

                                <Column field="totalInvoice" style="min-width: 100px;">
                                    <template #body="{ data }">
                                        {{ utils.formatDecimal(data.totalInvoice, 2) }}
                                    </template>
                                </Column>
                            </DataTable>
                        </template>
                    </Card>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type B'">
                    <DataTable :value="dataTollingFirstGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingFirst">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.quantities') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column field="total" style="min-width: 100px;" :header="$t('FinalInvoice.total')" frozen>
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.total, 3) }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsTollingFirstGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;" >
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type B'">
                    <DataTable :value="dataTollingSecondGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingSecond">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.trueUpPrice') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsTollingSecondGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type B'">
                    <DataTable :value="dataTollingThirdGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingThird">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.trueUpTollingValues') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column field="total" style="min-width: 100px;" :header="$t('FinalInvoice.total')" frozen>
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.total, 0) }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsTollingThirdGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type B'">
                    <DataTable :value="dataTollingFourthGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingFourth">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.tollingPrice') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsTollingFourthGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type B'">
                    <DataTable :value="dataTollingFifthGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingFifth">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.tollingInvoice') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column field="total" style="min-width: 100px;" :header="$t('FinalInvoice.total')" frozen>
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.total, 0) }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsTollingFifthGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <div class="col-12" v-if="trueUpType == 'Type B'">
                    <DataTable :value="dataTollingSixthGrid" showGridlines class="p-datatable-sm" stripedRows scrollable :loading="loadingFifth">
                        <template #header>
                            <h4>{{ $t('FinalInvoice.deltaAmount') }}</h4>
                        </template>

                        <Column field="description" header="Priced Qty" style="min-width: 100px;" frozen>
                            <template #body="{ data }">
                                {{ data.description }}
                            </template>
                        </Column>

                        <Column field="unitOfMeasureCode" :header="$t('FinalInvoice.unitOfMeasureCode')" frozen>
                            <template #body="{ data }">
                                {{ data.unitOfMeasureCode }}
                            </template>
                        </Column>

                        <Column field="total" style="min-width: 100px;" :header="$t('FinalInvoice.total')" frozen>
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.total, 0) }}
                            </template>
                        </Column>

                        <Column v-for="(column,index) in columnsTollingSixthGrid" :key="index" :header="column.label" style="text-align: end; min-width: 100px;">
                            <template #body="{ data }">
                                {{ utils.formatDecimal(data.data[column.data], column.decimalPrecision) }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </main>
</template>

<style>
    .grand-total{
        font-weight: bold;
    }
</style>
